import {inject, Injectable} from "@angular/core";
import {HttpClient, HttpHeaders, HttpResponse} from "@angular/common/http";
import {UrlBuilder} from "../item/url.item";
import {WrapperDto} from "../dto/wrapper.dto";
import {map} from "rxjs/operators";
import {InfoDto} from "../dto/info.dto";
import {Observable} from "rxjs";

@Injectable({providedIn: 'root'})
export class InfoRepo {

  private readonly infoRead = '/v1/info';
  private readonly infoPing = '/v1/ping';

  protected readonly http = inject(HttpClient);

  public ping(): Observable<HttpResponse<any>> {
    const url = UrlBuilder.builder().addPath(this.infoPing).build();
    const options: { headers?: HttpHeaders; observe?: 'body' | 'response' } = url.getOptions();
    options.observe = 'response';
    // @ts-ignore
    return this.http.get(url.getUrl(), options);
  }

  public getInfo(): Observable<WrapperDto<InfoDto>> {
    const url = UrlBuilder.builder().addPath(this.infoRead).deleteHttpHeader(UrlBuilder.API_HEADER).build();
    return this.http.get<WrapperDto<InfoDto>>(url.getUrl(), url.getOptions())
      .pipe(map((res) => new WrapperDto(res)));
  }
}
